import fetchJsonp from 'fetch-jsonp';
import qs from 'qs';
export default class Dashi {
  /**
   * 获取当前用户的云大使信息，如果不是云大使，则返回null
   */
  static async info() {
    return fetchJsonp('//promotion.aliyun.com/promotion/ambassador/getAmbassadorBasicInfo.htm', {
      jsonpCallback: 'cback',
    })
      .then(res => res.json())
      .then(res => {
        if (res.code == 200) {
          return {
            userCode: res.data.userCode,
          };
        } else {
          return null;
        }
      });
  }
  /**
   * 校验是否有资格成为云大使
   */
  static async verify() {
    return fetchJsonp('//promotion.aliyun.com/promotion/ambassador/checkAccountForAmbassador.htm', {
      jsonpCallback: 'cback',
    })
      .then(res => res.json())
      .then(res => {
        if (res.code == 200) {
          return {
            status: true,
          };
        } else {
          return {
            status: false,
            errorCode: res.code,
            msg: res.msg,
          };
        }
      });
  }
  /**
   * 成为云大使
   */
  static async join() {
    const params = {
      source: JSON.stringify({
        spma: '5176',
        spmb: document.querySelector('body').dataset.spm,
      }),
    };
    return fetchJsonp(`//promotion.aliyun.com/promotion/ambassador/applyAmbassador.htm?${qs.stringify(params)}`, {
      jsonpCallback: 'cback',
    })
      .then(res => res.json())
      .then(res => {
        if (res.code == 200) {
          return {
            status: true,
          };
        } else {
          return {
            status: false,
            errorCode: res.code,
            msg: res.msg,
          };
        }
      });
  }
  /**
   * 访问即关联
   * @param {string} userCode 云大使Code
   */
  static async bind(userCode) {
    const params = {
      userCode: userCode,
      source: JSON.stringify({
        spma: '5176',
        spmb: document.querySelector('body').dataset.spm,
      }),
    };
    return fetchJsonp(`//promotion.aliyun.com/promotion/ambassador/shareBuildRelation.htm?${qs.stringify(params)}`, {
      jsonpCallback: 'cback',
    })
      .then(res => res.json())
      .then(res => {
        if (res.code == 200) {
          return {
            status: true,
          };
        } else {
          return {
            status: false,
            errorCode: res.code,
            msg: res.msg,
          };
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/dashi.js